import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/HeaderAdmin';
import './Feedbacks.css';
import { ALL_FEEDBACKS_URL } from '../ApiDetails.js';
import defaultImage from "../../images/default.jpg";
import { useNavigate } from "react-router-dom";
function Feedbacks() {

  // Page data
  const [feedbacks, setFeedbacks] = useState([]);
  // Copy animation
  const [copiedIndex, setCopiedIndex] = useState(null);
  // Filters / sorting
  const [dataFilter, setDataFilter] = useState({
    startDate: "",
    endDate: ""
  });
  const [sortBy, setSortBy] = useState("Newest");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetchFeedbacks();
  }, []);

  const fetchFeedbacks = async () => {
    try {
      const response = await axios.get(ALL_FEEDBACKS_URL);
      setFeedbacks(response.data);
    } catch (error) {
      console.error('Error fetching feedbacks:', error);
    }
  };

  const copyFeedbackText = async (e, text, index) => {
    e.stopPropagation(); // Prevent navigation

    try {
    await navigator.clipboard.writeText(text);
    setCopiedIndex(index);

    setTimeout(() => {
        setCopiedIndex(null);
    }, 2000);
    } catch (err) {
    console.error("Failed to copy text:", err);
    }
  };

  // Apply Filter button logic
  const handleApplyFilterClick = async () => {
    setIsLoading(true);
    try {
      const {
        startDate,
        endDate,
      } = dataFilter;

      // Initialize URLSearchParams object
      const filterParams = new URLSearchParams();

      if (startDate) { filterParams.append("StartDate", startDate); }
      if (endDate) { filterParams.append("EndDate", endDate); }

    } catch (error) {
      console.error("Error in handleApplyFilterClick:", error);
    } finally {
      setIsLoading(false); // Set loading to false after the fetch is complete
    }
  };

  // Clear All button logic
  const handleClearAllFilters = () => {
    setDataFilter((prevState) => ({
      ...prevState,
      startDate: "",
      endDate: "",
    }));
  };

return (
    <>
      <Header />
      <div className="container-fluid" style={{ height:"80vh", width:"100vw" }}>
        
        <div className="row single-card-container align-items-center">
          <div className="cards align-items-center" style={{ height:"100%" }}>
            <div className="d-flex bd-highlight align-items-center">
              <div className="col-10 d-flex align-items-center flex-wrap" style={{ width:"100%" }}>
                <h4 className="col-1 reportTitle align-items-center" style={{ height:"100%" }}>FEEDBACK OVERVIEW</h4>
                <div className="col-9 row align-items-center " style={{ width:"90%", height:"100%" }}>
                  <div className="col-3">
                    <div className="input-group">
                      <label className="input-group-text input-group-text-custom" htmlFor="startDate">START DATE</label>
                      <input
                        type="date"
                        className="form-control-custom rounded form-control selectDateInput text-cursor"
                        id="startDate"
                        value={dataFilter.startDate} // Bind value to state
                        onChange={(e) => { setDataFilter({ ...dataFilter, startDate: e.target.value, });}} />
                    </div>
                  </div>
                  <div className="col-3">
                    <div className="input-group">
                      <label className="input-group-text input-group-text-custom" htmlFor="endDate">END DATE</label>
                      <input
                        type="date"
                        className="form-control-custom rounded form-control selectDateInput text-cursor"
                        id="endDate"
                        value={dataFilter.endDate} // Bind value to state
                        onChange={(e) => { setDataFilter({ ...dataFilter, endDate: e.target.value, });}} />
                    </div>
                  </div>
                  <div className="col-3">
                        <div className="input-group">
                            <label className="input-group-text input-group-text-custom" htmlFor="sortBy">Sort By</label>
                            <select
                                className="form-control-custom rounded form-select"
                                aria-label="Sort By"
                                id="sortBy"
                                value={sortBy}
                                onChange={(e) => { setSortBy(e.target.value); 
                                                   feedbacks.sort((a, b) => {
                                                   if (e.target.value === "Newest") return new Date(b.eventDate) - new Date(a.eventDate);
                                                   else if (e.target.value === "Oldest") return new Date(a.eventDate) - new Date(b.eventDate);
                                                   return 0; })}}                                        >
                                <option value="Newest">Newest</option>
                                <option value="Oldest">Oldest</option>
                            </select>
                        </div>
                  </div>
                <div className="row col-3 align-items-center">
                  <div className="col-6">
                    <button className="btn-primary-custom" style={{ height:"70%",paddingLeft:"4px",paddingRight:"4px"}} onClick={handleApplyFilterClick}>Apply filter</button>
                  </div>
                  <div className="col-3">
                    <button className="btn-secondary-custom" style={{ height:"100%" }} onClick={handleClearAllFilters}>Clear all</button>
                  </div>
                </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div className="row single-card-container filter">
          <div className="cards">
        <div className="rounded" style={{ height:"70vh", width:"100%", overflowY: "auto" }}>
            {feedbacks
                .filter(fb => (!dataFilter.startDate || (new Date(dataFilter.startDate).getTime()<=new Date(fb.eventDate).getTime())) 
                           && (!dataFilter.endDate || (new Date(dataFilter.endDate).getTime()>=new Date(fb.eventDate).getTime())))
                .map((feedback, index) => (
              <div key={index} className="row m-2 align-items-center">
                <div className="col-sm-2 d-flex" onClick={() => { navigate(`/getDetail/postevent/${feedback.eventId}`, { state: { }, }); }} style={{cursor:"pointer"}}>
                  <div className="col">
                  <h6 className='card-header-custom line-clamp-2' title={feedback.eventTitle}>{feedback.eventTitle}</h6>                              
                  <div className="card-img-container">
                      {feedback.eventCover
                          ? <img
                              className="card-img-top-custom card-img-top rounded"
                              src={feedback.eventCover ?? defaultImage}
                              alt={feedback.eventTitle} />
                          : <div className='card-noimg-text'>
                              <span className='line-clamp-3'>{feedback.eventTitle}</span>
                          </div>}
                  </div>
                  </div>
                </div>
                <div className="col-sm-8 text-left bg" onClick={() => { navigate(`/getDetail/postevent/${feedback.eventId}`, { state: { }, }); }} style={{cursor:"pointer"}}>
                    <h4 className="text-left mt-2">
                      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                          <g clipPath="url(#clip0_992_26907)">
                          <rect x="0.5" width="24" height="24" rx="12" fill="#0000A0" />
                          <rect x="7.5" y="4" width="10" height="10" rx="5" fill="#FFDC00" />
                          <rect x="-5.5" y="16" width="36" height="36" rx="18" fill="#FFDC00" />
                          </g>
                          <defs>
                          <clipPath id="clip0_992_26907">
                              <rect x="0.5" width="24" height="24" rx="12" fill="white" />
                          </clipPath>
                          </defs>
                      </svg>
                      &nbsp;
                      {feedback.feedbackUserName} - {new Date(feedback.createdDate).toLocaleDateString('en-US', {timeZone: 'UTC'})}
                      &nbsp;-&nbsp;
                          <strong>
                          <span style={{ color: "#ffd32c", fontSize: "24px" }}>
                              {Array(feedback.feedbackRating)
                              .fill("★")
                              .map((star, index) => (
                                  <span
                                  key={index}
                                  style={{
                                      color: "#ffd32c",
                                      fontSize: "24px",
                                  }}
                                  >
                                  {star}
                                  </span>
                              ))}
                          </span>
                          <span style={{ color: "lightgray", fontSize: "24px" }}>
                              {Array(5 - feedback.feedbackRating)
                              .fill("☆")
                              .map((star, index) => (
                                  <span
                                  key={index}
                                  style={{
                                      color: "lightgray",
                                      fontSize: "24px",
                                  }}
                                  >
                                  {star}
                                  </span>
                              ))}
                          </span>
                          </strong>
                    </h4>
                  <p className="text-left p-0 m-0" style={{ wordWrap: "break-word", whiteSpace: "pre-wrap", maxHeight: "128px", overflowY: "auto" }}>
                    {feedback.feedbackDescription}
                  </p>
                </div>
                <div className="col d-flex align-items-center text-center justify-content-center" style={{minHeight:"100%"}}>
                    <button type="button" className="btn btn-sm btn-outline-secondary" title="Copy feedback" onClick={(e) => copyFeedbackText(e, feedback.feedbackDescription,index)}>
                    {copiedIndex === index ? "✓ Copied" : "Copy feedback"}
                    </button>
                </div>
              </div>
            ))}
        </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Feedbacks;